import React from 'react'

import { FormsElementTypeEnum, ProcurementTypeItemFragment } from 'generated/resources/graphql'

import { Form, FormEditor, FormPreviewInline } from 'modules/forms'

const PERMITTED_FIELD_TYPES: FormsElementTypeEnum[] = [
  'longtext',
  'multiselect',
  'number',
  'section',
  'select',
  'text',
  'url',
  'dropdownsingle',
  'date',
]

interface Props {
  requestType: ProcurementTypeItemFragment
  isCustomFormsEnabled: boolean
  form?: Form
  onPreviewClick: () => void
}

const FormTab = ({ requestType, isCustomFormsEnabled, form, onPreviewClick }: Props) => {
  if (!isCustomFormsEnabled) {
    return null
  }

  if (!form) {
    return null
  }

  const formIsDraft = form?.status === 'draft'

  return formIsDraft ? (
    <FormEditor
      formId={form.id}
      resourceType="Procurement::Type"
      permittedFieldTypes={PERMITTED_FIELD_TYPES}
      showElementName={false}
      titleSize="small"
    />
  ) : (
    <FormPreviewInline
      formId={form.id}
      resourceId={requestType?.id?.toString() || ''}
      resourceType="Procurement::Type"
      showElementName={false}
      titleSize="small"
    />
  )
}

export default FormTab
